import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { throwError } from 'rxjs';
import {
    GeneralResponse
} from 'src/app/global/interfaces/general-response';
import { NotificacionCorreoServiceVM } from 'src/app/view-model/services/notificacion-correo-vm.service';
import { NotificacionCorreoService } from 'src/app/view-model/services/notificacion-correo.service';

@Injectable()
export class NotificacionCorreoProviderVM extends NotificacionCorreoServiceVM {
  respuestaNotificacion: GeneralResponse<any>;

  constructor(private notificacionService: NotificacionCorreoService) {
    super();
  }

  public async guardarCorreoNotificacion(form: FormGroup): Promise<GeneralResponse<any>> {
    if (!form.valid) {
      throw new Error('Formulario Inválido');
    }
    const correo = form.get('correo').value;
    const tipoNotificacion = form.get('tipoNotificacion').value;
    const telefono = form.get('telefono').value;
    const response: GeneralResponse<any> = await this.notificacionService.guardarCorreoNotificacion(correo, telefono, tipoNotificacion).toPromise();
    this.respuestaNotificacion = response;
    if (response === null) {
      throw new Error('Notification error');
    }
    return this.respuestaNotificacion;
  }

  private responseValid = (response) => response.mensaje;

  private serviceError(error) {
    return throwError(error);
  }
}
